import React from 'react';
import PropTypes from 'prop-types';

import { useSelector } from 'react-redux';

import PanelContent from '../../common/PanelContent';
import Planning from '../../common/planning/Planning';

const propTypes = {
    // Redux State
    applications: PropTypes.array
};

const defaultProps = {
    applications: null
};

function PlanningTab () {
    const applications = useSelector((state) => {
        const currentPolygon = state.parcelPanel.currentPolygonId && state.parcelPanel.polygons[state.parcelPanel.currentPolygonId];
        return currentPolygon && currentPolygon.planning;
    });

    return (<PanelContent>
        <Planning applications={applications} />
    </PanelContent>);
}

PlanningTab.propTypes = propTypes;
PlanningTab.defaultProps = defaultProps;

export default PlanningTab;